export default "__VITE_ASSET__155de9ff__"